import { CanActivateFn, Router } from '@angular/router';
import { inject } from '@angular/core';
import { SpaActivatedRouteSnapshot, SpaRedirectActivatedRouteSnapshot } from './models';
import { FeatureToggleService } from './feature-toggle.service';

export const featureToggleGuard: CanActivateFn = (route: SpaActivatedRouteSnapshot) => {
  const featureToggleService = inject(FeatureToggleService);
  const router = inject(Router);
  const desiredFeatures = route.data?.features;
  if (!desiredFeatures) {
    return true;
  }

  const canActivate = featureToggleService.hasFeature(desiredFeatures);
  if (!canActivate) {
    return router.parseUrl('/home');
  }
  return true;
};

export const featureRedirectGuard: CanActivateFn = (route: SpaRedirectActivatedRouteSnapshot) => {
  const featureToggleService = inject(FeatureToggleService);
  const router = inject(Router);
  const redirects = route.data?.redirect;
  if (!redirects) {
    return true;
  }

  for (const redirect of redirects) {
    if (!redirect.features) {
      continue;
    }
    const canActivate = featureToggleService.hasFeature(redirect.features);
    if (!canActivate) {
      if (redirect.path.includes(':')) {
        const path = redirect.path.split('/');
        const activatedRoute = route;

        const resolvedPath = path.map((segment) => {
          if (segment.startsWith(':')) {
            const paramName = segment.slice(1);
            return activatedRoute.params[paramName];
          }
          return segment;
        });

        return router.parseUrl(resolvedPath.join('/'));
      }
      return router.parseUrl(redirect.path);
    }
  }
  return true;
};
